const UiTextareaPropsOption = {
  placeholder: { type: String },
  //* 提示文本
  modelValue: { type: [String, Number], required: true },
  maxlength: { type: Number },
  disabled: { type: Boolean, default: false },
  //* 是否禁用
  readonly: { type: Boolean, default: false },
  //* 是否只读
  loading: { type: Boolean, default: false },
  //* 是否启动内置loading
  height: { type: [String, Number] },
  width: { type: [String, Number] },
  name: { type: String },
  rows: { type: Number, default: 3 }
};
const UiTextareaEmits = {
  "update:modelValue": (_data) => true,
  "change": (_ev) => true,
  "clear": () => true,
  "input": (_ev) => true,
  "click": (_ev) => true,
  "enter": (_ev) => true,
  "focus": (_ev) => true,
  "blur": (_ev) => true
};

export { UiTextareaEmits, UiTextareaPropsOption };
//# sourceMappingURL=index.mjs.map
